import React, { useState } from 'react';
import { SiteLink } from '../../../../components';
import env from '../../../../env';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [pending, setPending] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    
    if (!email) {
      setError('Please enter your email address.');
      return;
    }

    setPending(true);
    setError('');

    try {
      const response = await fetch(env.apiBase + '/api/profile/sendpasswordresetemail', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email })
      });

      const data = await response.json();
      
      if (data.errors && data.errors.length > 0) {
        setError(data.errors[0].errorMessage);
        setPending(false);
      } else {
        setSuccess(true);
        setPending(false);
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
      setPending(false);
    }
  }

  return (
    <div className="forgot-password auth-panel" style={{ maxWidth: '600px', margin: 'auto' }}>
      <h1>Reset Password</h1>
      <div className="loading-panel-holder">
        <div className="panel-content">
          {success ? (
            <div>
              <div style={{ 
                backgroundColor: '#d4edda', 
                color: '#155724', 
                padding: '1rem', 
                borderRadius: '5px',
                marginBottom: '1rem'
              }}>
                <strong>Email Sent!</strong>
                <p style={{ marginBottom: 0, marginTop: '0.5rem' }}>
                  Password reset email has been sent to <strong>{email}</strong>. 
                  Please check your inbox (and junk folder).
                </p>
              </div>
              <div className="text-center">
                <SiteLink to="/login" style={{ color: '#e21d20', fontWeight: 'bold' }}>
                  Back to Log In
                </SiteLink>
              </div>
            </div>
          ) : (
            <form method="POST" noValidate="" onSubmit={handleSubmit}>
              <p style={{ color: '#666', marginBottom: '1.5rem' }}>
                Enter your email address and we'll send you a link to reset your password.
              </p>
              
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  id="email"
                  type="email"
                  className="form-control"
                  name="email"
                  required
                  autoFocus
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              {error && (
                <div style={{ color: 'red', marginBottom: '1rem' }}>
                  {error}
                </div>
              )}

              <div className="form-group m-0">
                <button type="submit" disabled={pending} className="btn btn-primary btn-block">
                  {pending && <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>}
                  <span>Reset Password</span>
                </button>
              </div>

              <div className="text-center mt-3">
                Remember your password?{' '}
                <SiteLink to="/login" style={{ color: '#e21d20', fontWeight: 'bold', textDecoration: 'underline' }}>
                  Log in
                </SiteLink>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

